module.exports = __webpack_public_path__ + "static/media/userIcon.877a015e.svg";